






































































import { computed, defineComponent } from "@vue/composition-api";
import { EventPost, EventPostStatus } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatDate, getDurationSymbols } from "@/lib/time";
import { getAbsUrl, getLiveUrl, getProfileUrl, shareUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { BaseMenuItem } from "@/types";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "EventsListItem",
  components: { BaseAvatar, BaseIconButton, BaseIcon, BaseMenu, FormatMoney, BaseButton },
  props: {
    userId: { type: String, required: true },
    event: { type: Object as () => EventPost, required: true },
  },
  setup(props, { root, emit }) {
    const date = computed(() =>
      formatDate(new Date(props.event.time), { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    );

    const durationSymbols = computed(() => getDurationSymbols(Math.floor(props.event.duration * 60 * 1000)));
    const duration = computed(() => {
      const h = durationSymbols.value.h;
      const m = durationSymbols.value.m;
      return m !== 0 ? (h === 0 ? `${m}m` : `${h}h ${m}m`) : `${h}h`;
    });

    const amount = computed(() => (props.event.ticketPricePackage ? props.event.ticketPricePackage.amount : 0));
    const isBuyer = computed(() => props.userId !== props.event.userId);
    const totalEarnings = computed(() => amount.value * props.event.ticketsBooked);
    const ticketLink = computed(() => getProfileUrl(props.event.user, { feedId: props.event.postId }));

    const shareLink = computed(() => getProfileUrl(props.userId, { feedId: props.event.postId }));
    const eventStarted = computed(
      () => props.event.status === EventPostStatus.STARTED || props.event.status === EventPostStatus.READY_TO_START
    );

    const items: BaseMenuItem[] = [
      ...(isBuyer.value
        ? !eventStarted.value
          ? [{ name: "cancelEvent", text: $t("Cancel booking") }]
          : []
        : [
            { name: "share", text: $t("Share") },
            { name: "cancelEvent", text: $t("Cancel event") },
          ]),
    ];

    const onShareClick = () =>
      shareUrl(getAbsUrl(`${root.$router.resolve(shareLink.value)?.href || ""}`), $t("Link copied"));

    const handleCancelEvent = () => {
      emit("cancelEvent", props.event.postId, isBuyer.value);
    };

    const goLive = () => {
      const liveOwnUrl = getLiveUrl(props.event.user);
      router.push(liveOwnUrl);
    };

    return {
      date,
      items,
      duration,
      amount,
      totalEarnings,
      isBuyer,
      ticketLink,
      eventStarted,
      onShareClick,
      goLive,
      handleCancelEvent,
    };
  },
});
